// components/Courses/CourseCard.js
import React from "react";
import { Badge } from "react-bootstrap";
import { BookOpen, Users, Clock, MoreVertical, Eye, Edit, Trash2, GraduationCap } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { formatToCurrency } from "../../utils/common";
import { ActionMenu, ActionMenuItem, ActionMenuDivider } from "../ui";

const CourseCard = ({ course, onDelete }) => {
  const navigate = useNavigate();

  const viewCourse = () => {
    navigate(`/courses/${course._id}`);
  };

  const statusConfig = {
    active: { label: 'Active', variant: 'success' },
    upcoming: { label: 'Upcoming', variant: 'warning' },
    completed: { label: 'Completed', variant: 'primary' }
  };

  const status = course.status?.toLowerCase() || 'active';
  const statusInfo = statusConfig[status] || statusConfig.active;

  return (
    <div className="course-card">
      <div className="course-card-header">
        <div className="d-flex align-items-center gap-3 flex-grow-1" style={{ minWidth: 0 }}>
          <div className="course-icon-wrapper">
            <BookOpen size={20} />
          </div>
          <div className="flex-grow-1 clickable-selector" onClick={viewCourse} style={{ minWidth: 0 }}>
            <div className="course-card-name">{course.name}</div>
            <div className="course-card-code">
              {course.shortCode && (
                <span className="course-card-shortcode">{course.shortCode}</span>
              )}
              {course.title || `VC_${course.name.split(' ')[0]}`}
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Badge bg={statusInfo.variant} className="course-card-badge">
            {statusInfo.label}
          </Badge>
          <ActionMenu trigger={<MoreVertical size={16} />}>
              <ActionMenuItem onClick={viewCourse}>
                <Eye size={16} /> View Details
              </ActionMenuItem>
              <ActionMenuItem onClick={() => navigate(`/courses/edit/${course._id}`)}>
                <Edit size={14} /> Edit
              </ActionMenuItem>
              <ActionMenuDivider />
              <ActionMenuItem danger onClick={() => onDelete && onDelete(course._id)}>
                <Trash2 size={14} /> Delete
              </ActionMenuItem>
            </ActionMenu>
        </div>
      </div>

      <div className="course-card-description">
        {course.description || `Complete ${course.name} course with hooks, context, Redux, Next.js, TypeScript, and modern frontend development practices`}
      </div>

      <div className="course-card-stats">
        <div className="course-stat-item course-stat-duration">
          <Clock size={14} />
          <span>{course.duration || '3 Months'}</span>
        </div>
        <div className="course-stat-item course-stat-enrolled">
          <Users size={14} />
          <span>{course.studentCount || 0} enrolled</span>
        </div>
      </div>

      <div className="course-card-footer">
        <div className="course-card-price">
          {course.fees ? formatToCurrency(course.fees) : <span style={{ color: 'var(--text-secondary)', fontWeight: 400 }}>No fee set</span>}
        </div>
        <Badge bg="secondary" className="course-batches-badge">
          <GraduationCap size={12} className="me-1" />
          {course.batchCount || 0} Batches
        </Badge>
      </div>
    </div>
  );
};

export default CourseCard;
